// @flow strict
import SiteSidebar from './SiteSidebar';

export default SiteSidebar;
